import { render, staticRenderFns } from "./Roads.vue?vue&type=template&id=6fbb58f0&scoped=true"
import script from "./Roads.vue?vue&type=script&lang=js"
export * from "./Roads.vue?vue&type=script&lang=js"
import style0 from "./Roads.vue?vue&type=style&index=0&id=6fbb58f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb58f0",
  null
  
)

export default component.exports